import { RequestParams } from '@bv/api';
import { WithPagination } from '@bv/api/crud';

import type { StepConfig } from '../../types/workflow';

class TagsApi extends WithPagination {
  constructor() {
    super('contacts/tags');
  }
}

const tagsApi = new TagsApi();

const updateContactTag: StepConfig = {
  icon: 'UpdateContactTag',
  headerTextColor: '#BE7B25',
  headerColor: '#FFFAF2',
  title: 'Updated Contact Tag',
  text: 'Action : Add tag',
  category: 'Node',
  desc: 'Adds or removes one or many contact tags.',
  primaryKey: 'operation',
  formFields: [
    {
      key: 'operation',
      label: 'Action :',
      type: 'select',
      defaultValue: 'add',
      options: [
        { label: 'Add Tag', value: 'add' },
        { label: 'Remove Tag', value: 'remove' },
      ],
    },
    {
      key: 'tags',
      label: 'Tags',
      type: 'multiSelect',
      searchKey: 'filter[q]',
      defaultValue: [],
      validation: {
        required: true,
        minSelections: 1,
        maxSelections: 5,
      },
      options: () => {
        // Return a function that will be called by FormField to fetch tags using the API instance
        return async (config?: { params?: RequestParams }) => {
          const { data, meta } = await tagsApi.paginated(config);
          return {
            meta,
            data: (data as Array<{ name: string; id: string }>).map((tag) => ({
              label: tag.name,
              value: tag.name,
            })),
          };
        };
      },
    },
  ],
};

export default updateContactTag;
